import { render, staticRenderFns } from "./ScreeningListPage.vue?vue&type=template&id=b1a0fcd6&scoped=true"
import script from "./ScreeningListPage.vue?vue&type=script&lang=js"
export * from "./ScreeningListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a0fcd6",
  null
  
)

export default component.exports